"use strict";

exports.__esModule = true;
exports.getRandomTheme = getRandomTheme;

var _ = require("./");

function getRandomTheme() {
  const primaryColor = (0, _.getRandomColor)();
  const theme = {
    primaryColor: primaryColor
  };
  return theme;
}